import $apiJSON from '../http/apiJSON'

// Gaming Servers API Service

export async function getServers(params = {}) {
  return $apiJSON.get('servers/servers/', { params })
}

export async function getServer(slug) {
  return $apiJSON.get(`servers/servers/${slug}/`)
}

export async function getServerTypes() {
  return $apiJSON.get('servers/types/')
}

export async function getServerRegions() {
  return $apiJSON.get('servers/regions/')
}

export async function getFeaturedServers() {
  return $apiJSON.get('servers/servers/featured/')
}

export async function getPopularServers() {
  return $apiJSON.get('servers/servers/popular/')
}

export async function getServerReviews(slug, params = {}) {
  return $apiJSON.get(`servers/servers/${slug}/reviews/`, { params })
}

export async function addServerReview(slug, data) {
  return $apiJSON.post(`servers/servers/${slug}/add-review/`, data)
}

export async function getServerStatistics(slug) {
  return $apiJSON.get(`servers/servers/${slug}/statistics/`)
}

export async function getServerNews(slug, params = {}) {
  return $apiJSON.get(`servers/servers/${slug}/news/`, { params })
}

export async function toggleServerFavorite(slug) {
  return $apiJSON.post(`servers/servers/${slug}/toggle-favorite/`)
}

export async function getFavoriteServers() {
  return $apiJSON.get('servers/favorites/')
}

export async function addToFavorites(serverId) {
  return $apiJSON.post('servers/favorites/', { server_id: serverId })
}

export async function removeFromFavorites(id) {
  return $apiJSON.delete(`servers/favorites/${id}/`)
}

export async function getServersByType(type) {
  return $apiJSON.get('servers/servers/', { params: { type } })
}

export async function getServersByRegion(region) {
  return $apiJSON.get('servers/servers/', { params: { region } })
}

export async function getOnlineServers() {
  return $apiJSON.get('servers/servers/', { params: { online_only: true } })
}

export async function searchServers(query) {
  return $apiJSON.get('servers/servers/', { params: { search: query } })
}

export async function getServerStats() {
  return $apiJSON.get('servers/stats/')
}

export async function getNews(params = {}) {
  return $apiJSON.get('servers/news/', { params })
}

export async function getNewsItem(slug) {
  return $apiJSON.get(`servers/news/${slug}/`)
}

export async function getStatistics(params = {}) {
  return $apiJSON.get('servers/statistics/', { params })
}

export async function getReviews(params = {}) {
  return $apiJSON.get('servers/reviews/', { params })
}

export async function addReview(data) {
  return $apiJSON.post('servers/reviews/', data)
}

export async function updateReview(id, data) {
  return $apiJSON.put(`servers/reviews/${id}/`, data)
}

export async function deleteReview(id) {
  return $apiJSON.delete(`servers/reviews/${id}/`)
}

// Класс-обертка для удобства использования
class ServersService {
  static getServers = getServers
  static getServer = getServer
  static getServerTypes = getServerTypes
  static getServerRegions = getServerRegions
  static getFeaturedServers = getFeaturedServers
  static getPopularServers = getPopularServers
  static getServerReviews = getServerReviews
  static addServerReview = addServerReview
  static getServerStatistics = getServerStatistics
  static getServerNews = getServerNews
  static toggleServerFavorite = toggleServerFavorite
  static getFavoriteServers = getFavoriteServers
  static addToFavorites = addToFavorites
  static removeFromFavorites = removeFromFavorites
  static getServersByType = getServersByType
  static getServersByRegion = getServersByRegion
  static getOnlineServers = getOnlineServers
  static searchServers = searchServers
  static getServerStats = getServerStats
  static getNews = getNews
  static getNewsItem = getNewsItem
  static getStatistics = getStatistics
  static getReviews = getReviews
  static addReview = addReview
  static updateReview = updateReview
  static deleteReview = deleteReview

  // Устаревшие методы для обратной совместимости
  static getMyServers = getServers
  static getOverallStats = getServerStats
}

export default ServersService